import { useEffect, useState } from 'react';

export const DEFAULT_WIDTH_TO_DESKTOP = 1000;
export const DEFAULT_WIDTH_TO_TABLET = 500;

const getWindowWidth = () => {
  if (typeof window !== 'undefined') {
    return window.innerWidth;
  }
  return DEFAULT_WIDTH_TO_DESKTOP;
};

const initialWindowWidth = getWindowWidth();

export type ActualSize = 'Desktop' | 'Mobile';
export const actualSize: ActualSize =
  initialWindowWidth > DEFAULT_WIDTH_TO_DESKTOP ? 'Desktop' : 'Mobile';

export const ACTUAL_WINDOW_WIDTH = initialWindowWidth;

export function useMobile() {
  const [windowWidth, setWindowWidth] = useState(getWindowWidth());

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(getWindowWidth());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth <= DEFAULT_WIDTH_TO_DESKTOP;
  const isDesktop = windowWidth > DEFAULT_WIDTH_TO_DESKTOP;
  const isSmallScreen = windowWidth <= DEFAULT_WIDTH_TO_TABLET;
  const currentActualSize: ActualSize = isDesktop ? 'Desktop' : 'Mobile';

  return {
    isMobile,
    isDesktop,
    isSmallScreen,
    actualSize: currentActualSize,
    ACTUAL_WINDOW_WIDTH: windowWidth,
  };
}
